import type { JSX } from 'react'
import type { INavGroup } from 'blocks/NavGroup'

import React, { Children } from 'react'
import { NavDirection } from 'atoms/NavTab'
import {
  NavAlignItems,
  NavGroup,
  NavGroupGap,
  NavJustifyContent,
} from 'blocks/NavGroup'
import { LinksBlockSC } from '../Footer.styled'

export interface ILinksBlock extends INavGroup {}

export const LinksBlock = ({
  children,
  direction = NavDirection.COLUMN,
  gapRow = NavGroupGap.SIZE_8,
  alignItems = NavAlignItems.FlexEnd,
  justifyContent = NavJustifyContent.FlexStart,
  ...rest
}: ILinksBlock): JSX.Element => {
  return (
    <LinksBlockSC>
      <NavGroup
        search={false}
        direction={direction}
        gapRow={gapRow}
        alignItems={alignItems}
        justifyContent={justifyContent}
        {...rest}
      >
        {Children.map(children, (child, index) => (
          <React.Fragment key={index}>{child}</React.Fragment>
        ))}
      </NavGroup>
    </LinksBlockSC>
  )
}
